const BASE_URL = 'https://back.iteller.app/v1/'
const SOCKET_URL = 'https://back.iteller.app/'

export { BASE_URL, SOCKET_URL }
